export default "__VITE_ASSET__d1e22f4a__"